export const EhrMainLayoutClassName = "addon";
